export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7828.7c48f680.jpg";